module.exports = __webpack_public_path__ + "img/FR24659.83fa8562.png";